import { Flex, Text } from '@mantine/core';
import cx from 'clsx';
import { ComponentType, ReactElement } from 'react';

import { CustomClassType } from '../UploadFile';
import classes from '../UploadFile.module.scss';

type DropzoneContentProps = {
  isRejected: boolean;
  Icon?: ComponentType;
  text?: string;
  subText?: string;
  isThumbnail?: boolean;
  CustomDropzoneContent?: ReactElement;
  customClassNames?: Partial<Record<CustomClassType, string>>;
  showOnlyLoaderWhenLoading?: boolean;
};

export function DropzoneContent(props: DropzoneContentProps) {
  const {
    Icon,
    text,
    isRejected,
    subText,
    isThumbnail,
    CustomDropzoneContent,
    customClassNames,
    showOnlyLoaderWhenLoading
  } = props;

  const ContentInner = () => {
    return CustomDropzoneContent && !isRejected ? (
      CustomDropzoneContent
    ) : (
      <Flex
        className={cx(
          classes.dropzoneContentText,
          { [classes.thumbnail]: isThumbnail },
          customClassNames?.dropzoneContentText
        )}
      >
        {text && (
          <Text fw={700} className={cx({ [customClassNames?.errorMessage ?? '']: isRejected })}>
            {text}
          </Text>
        )}
        {isThumbnail && subText && <Text>{subText}</Text>}
      </Flex>
    );
  };

  return (
    <Flex
      className={cx(
        classes.dropzoneContent,
        { [classes.rejected]: isRejected, [classes.thumbnail]: isThumbnail },
        customClassNames?.dropzoneContent
      )}
    >
      {Icon && (
        <Flex
          className={cx(
            classes.dropzoneIcon,
            { [classes.rejected]: isRejected, [classes.thumbnail]: isThumbnail },
            customClassNames?.dropzoneIcon
          )}
        >
          <Icon />
        </Flex>
      )}
      {!showOnlyLoaderWhenLoading && <ContentInner />}
    </Flex>
  );
}
